$(":input").on("change valid", function(){

    this.setCustomValidity("");

});

$(":input").on("invalid", function(){
    
    var $this = $(this);
    
    if($this.hasClass("datepicker")){
        this.setCustomValidity("Must be date in valid format mm/dd/yyyy!");
    }
    
});


// WEBPACK FOOTER //
// ./resources/assets/js/validate.js